export interface UserRole {
  id: number;
  name: string;
  description?: string;
}

export interface AuthUser {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  roleId: number;
  Role?: UserRole;
  role?: UserRole;
}

export const normalizeAuthUser = (user: AuthUser): AuthUser => {
  if (!user.Role && user.role) {
    return { ...user, Role: user.role };
  }

  return user;
};

export const getUserRoleName = (user: AuthUser | null): string => {
  if (!user) {
    return '';
  }

  return user.Role?.name ?? user.role?.name ?? '';
};

export const isAdminUser = (user: AuthUser | null): boolean => {
  if (!user) {
    return false;
  }

  const roleName = getUserRoleName(user).trim().toLowerCase();
  return roleName === 'admin' || user.roleId === 1;
};

export const isPlatformOwner = (user: AuthUser | null): boolean => {
  if (!user) {
    return false;
  }

  return getUserRoleName(user).trim().toLowerCase() === 'platform_owner';
};

/** Roles winery users may see/manage (excludes platform_owner). */
export const isWineryManagedRole = (role: { name?: string | null } | null | undefined): boolean => {
  if (!role?.name) {
    return true;
  }

  return role.name.trim().toLowerCase() !== 'platform_owner';
};
